<app-side-bar #sideBarComponent>
        <div class="fixed inset-y-0 right-0 z-40 w-full overflow-y-auto bg-card px-6 py-6 sm:max-w-md sm:ring-1 sm:border-button-primary-outline">
            <div class="flex items-center justify-between">
                <a [routerLink]="['/']" class="-m-1.5 p-1.5">
                    <span class="sr-only">{{whiteLabel?.name}}</span>
                    <img class="h-8 w-auto" [src]="whiteLabel?.logoUrl" [alt]="whiteLabel?.name">
                </a>
                <button type="button" (click)="sideBarComponent.toggleModalEmitter()" class="-m-1.5 rounded-md p-2.5 text-light">
                    <span class="sr-only">Close menu</span>
                    <svg class="size-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
            <div class="mt-6 flow-root">
                <div class="-my-6 divide-y divide-button-primary-outline">
                    <div class="space-y-2 py-6">
                        @for(item of whiteLabel?.header?.navigation?.value; track $index){
                            @if(item.navigation.value?.length > 0){
                                <div class="-mx-3">
                                    <button type="button" (click)="item.opened = !item.opened"
                                            class="flex w-full items-center justify-between rounded-lg py-2 pl-3 pr-3.5 text-base/7 font-semibold text-normal" aria-controls="disclosure-1" aria-expanded="false">
                                        {{item.label.value}}
                                        <!--
                                          Expand/collapse icon, toggle classes based on menu open state.

                                          Open: "rotate-180", Closed: ""
                                        -->
                                        <svg [ngClass]="{
                                            'rotate-180' : item.opened
                                            }" class="size-5 flex-none" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
                                            <path fill-rule="evenodd" d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
                                        </svg>
                                    </button>
                                    <!-- 'Product' sub-menu, show/hide based on menu state. -->
                                    <div class="mt-2 space-y-2" id="disclosure-1" [ngClass]="{
                                        'hidden': !item.opened
                                    }">
                                        @for(subItem of item.navigation.value; track $index){
                                            <a [routerLink]="subItem.link.value" (click)="sideBarComponent.toggleModalEmitter()" class="block rounded-lg py-2 pl-6 pr-3 text-sm/7 font-semibold text-normal ">
                                                {{subItem.label.value}}
                                            </a>
                                        }
                                    </div>
                                </div>

                            } @else {
                                <a [routerLink]="item.link.value" (click)="sideBarComponent.toggleModalEmitter()" class="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-semibold text-normal ">
                                    {{item.label.value}}
                                </a>
                            }
                        }
                    </div>
                    @if(!currentUser){
                        <div class="py-6">
                            <a [routerLink]="['/auth/signin']" class="-mx-3 block rounded-lg px-3 py-2.5 text-baslogoute/7 font-semibold text-normal">{{'signin' | translate}}</a>
                        </div>
                    } @else {
                        <div class="py-6">
                            <a  (click)="logOut()" class="group relative flex items-center gap-x-6 rounded-lg p-2 text-sm leading-6 hover:bg-card-hover">
                                <div class="flex  h-8 w-8 flex-none items-center justify-center rounded-lg text-normal bg-dark">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10 17L12 15L8 12L12 9L10 7L4 12L10 17Z" fill="currentColor"/>
                                        <path d="M16 5V19H20V5H16Z" fill="currentColor"/>
                                    </svg>

                                </div>
                                <div class="flex-auto">
                                    <div class="block font-semibold  text-normal">
                                        <span>{{'logout'| translate}}</span>
                                    </div>
                                </div>
                            </a>
                        </div>
                    }
                </div>
            </div>
        </div>

</app-side-bar>
